module.exports = __webpack_public_path__ + "img/eastcampusdeck-h-474x356.77e261dc.jpg";